var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('span',{staticClass:"rank"},[_vm._v("Rank "+_vm._s(_vm.format(_vm.rank))+"/"+_vm._s(_vm.format(_vm.total)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }